import { reatomAsync, withAbort } from "@reatom/async";
import { UpdateProductSelectionDto } from "definitions/product-storage/models/update-product-selection-dto";
import { API } from "src/api";
import { withDebounce, withIsLoadingAtom } from "src/common/pipes";

export const updateProductSelectionRequest = reatomAsync(
  async (ctx, selectionId: number, updateData: UpdateProductSelectionDto) => {
    return API.productSamplesApi
      .productSelectionControllerUpdate(
        { selectionId, updateProductSelectionDto: updateData },
        {
          signal: ctx.controller.signal,
        },
      )
      .then((response) => response.data);
  },
  "updateProductSelectionRequest",
).pipe(withAbort(), withIsLoadingAtom());

export const updateProductSelectionWithDebounceRequest =
  updateProductSelectionRequest.pipe(withDebounce(1000));
